import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { TableHeadCell } from "@digital-services/ui";
import { SortQueryDirection } from "@ds-cps/ui";

interface Props {
  handleSortHeaderClick: (val: string) => void;
  activeSort?: string;
  sortDirection?: SortQueryDirection;
}

export const ResourcesTableHeaderRow = (props: Props) => {
  const { activeSort, sortDirection, handleSortHeaderClick } = props;

  const { organizationId } = useParams();

  const serialNumber = "serial-number";
  const resourceType = "resource-type";
  const productFamilyName = "product-family-name";
  const owner = "owner"; // sorting is NOT possible
  const relationshipType = "relationship-type";
  const registeredAt = "registered-at";

  const { t: tResource } = useTranslation(undefined, {
    keyPrefix: "resource"
  });

  function renderTableHeadCell(columnName: string) {
    return (
      <TableHeadCell data-testid={`resources-table-column-${columnName}`}>
        {tResource(`table.headers.${columnName}`)}
      </TableHeadCell>
    );
  }

  function renderSortableTableHeadCell(columnName: string) {
    return (
      <TableHeadCell
        sortActive={activeSort === columnName}
        sortDirection={sortDirection}
        onSort={() => handleSortHeaderClick(columnName)}
        data-testid={`resources-table-column-${columnName}`}
      >
        <span>{tResource(`table.headers.${columnName}`)}</span>
      </TableHeadCell>
    );
  }

  return (
    <tr className="leading-[0px]">
      {renderSortableTableHeadCell(serialNumber)}
      {renderSortableTableHeadCell(resourceType)}
      {renderSortableTableHeadCell(productFamilyName)}
      {organizationId
        ? renderSortableTableHeadCell(relationshipType)
        : renderTableHeadCell(owner)}
      {renderSortableTableHeadCell(registeredAt)}
    </tr>
  );
};
